import React, { Component } from 'react';
import $ from "jquery";
import PdfViewer from './PdfViewer';
import Select from 'react-select';
import { decodeText } from '../libs/utils/Const';

class ReportStocksModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#reportStocksModal').on('hidden.bs.modal', function () {
            cleanData();
        });
    };

    render() {
        const {
            ReportsModel,
            ListProjects,
            wareHouses = [],
            ListItmsGrpCod,
            ChangeWhsCode,
            ChangeWhsCodeBySelect,
            ChangeFilter,
            ChangeLine,
            ChangeCheckExistDate,
            ChangeCheckExistNegative,
            ChangeCheckInformationBatch,
            ChangeCheckExist,
            ActualDate,
            ChangeInitialDate,
            GenerateReportStocks,
            TypeDoc,
            ListReports,
            ShowPDFViewer,
            CleanReportModel,
            MailTools,
            printhide,
            ShowFormatToPrint,
        } = this.props;

        const whsOptions = wareHouses
            ?.slice()
            ?.sort((a, b) => decodeText(a.WhsName)?.localeCompare(decodeText(b.WhsName)))
            ?.map(whs => ({
                value: whs.WhsCode,
                label: `${whs.WhsCode} - ${decodeText(whs.WhsName)}`,
                WhsName: whs.WhsName
            }));

        return (
            <div className="modal fade" id="reportStocksModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="reportStocksModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-lg modal-dialog-centered" >
                    <div className="modal-content">
                        <div className="modal-header" style={{ background: "#343a40" }}>
                            <h5 style={{ color: "white" }}>Reporte de Existencias</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ color: "white" }} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className='row d-flex justify-content-center'>
                                {/* <div className='col-12 col-lg-4'> */}
                                <div className='col-12 col-lg-9'>
                                    <div className="input-group mb-3">
                                        <div className='input-group-prepend'>
                                            <span className='input-group-text font-weight-bold'> Almacén </span>
                                        </div>
                                        <Select
                                            options={whsOptions}
                                            value={whsOptions?.find(opt => opt.value === ReportsModel.WhsCode) || null}
                                            onChange={(event) => ChangeWhsCodeBySelect(event)}
                                            placeholder="Escribe para buscar un almacén"
                                            isSearchable={true}
                                            isClearable={true}
                                            menuPortalTarget={document.body}
                                            noOptionsMessage={() => 'No se encontraron coincidencias'}
                                            styles={{
                                                container: (base) => ({ ...base, flex: 1 }),
                                                control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                                input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                                singleValue: (base) => ({ ...base, color: "#000" })
                                            }} />
                                        {/* <select
                                            className="form-control"
                                            value={ReportsModel.WhsCode}
                                            onChange={event => ChangeWhsCode(event)} >
                                            <option value="---">Selecciona un almacén</option> */}
                                            {/* {!!ListProjects && ListProjects.map(list => <option value={list.PrjCode}> {list.PrjName} </option> )} */}
                                            {/* {!!WhsCodes && WhsCodes.map(whs => <option value={whs.WhsCode}> {whs.WhsName} </option> )}
                                        </select> */}
                                    </div>
                                </div>

                                <div className='col-12 col-lg-4'>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold"> Filtrar por </span>
                                        </div>
                                        <select
                                            className="form-control"
                                            value={ReportsModel.Filter}
                                            onChange={event => ChangeFilter(event)} >
                                            <option value="---">Selecciona</option>
                                            {/* <option value="1">Departamento</option> */}
                                            <option value="2">Línea</option>
                                        </select>
                                    </div>
                                </div>

                                {ReportsModel.Filter === '1' &&
                                    <div className='col-12 col-lg-4'>
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold"> Departamento </span>
                                            </div>
                                            <select
                                                className="form-control"
                                                value={ReportsModel.Departament}
                                                onChange={event => ChangeLine(event)} >
                                                <option value="---">Todos</option>
                                            </select>
                                        </div>
                                    </div>
                                }

                                {ReportsModel.Filter === '2' &&
                                    <div className='col-12 col-lg-4'>
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold"> Línea </span>
                                            </div>
                                            <select
                                                className="form-control"
                                                value={ReportsModel.Line}
                                                onChange={event => ChangeLine(event)} >
                                                <option value="---">Todos</option>
                                                {!!ListItmsGrpCod && ListItmsGrpCod.map(list => <option value={list.ItmsGrpCod}> {list.ItmsGrpNam} </option> )}
                                            </select>
                                        </div>
                                    </div>
                                }
                            </div>

                            <div className='row d-flex justify-content-center'>
                                <div className='col-12 col-lg-6'>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <div className="form-check input-group-text">
                                                <input
                                                    type="checkbox"
                                                    id="checkExist"
                                                    checked={ReportsModel.checkExist}
                                                    onClick={ChangeCheckExist} />
                                            </div>
                                        </div>
                                        <label className="form-control" htmlFor="checkExist"> Mostrar solo artículos con existencia </label>
                                    </div>
                                </div>
                                {/* <div className='col-12 col-lg-6'>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <div className="form-check input-group-text">
                                                <input
                                                    type="checkbox"
                                                    id="checkExistDate"
                                                    checked={ReportsModel.checkExistDate}
                                                    onClick={ChangeCheckExistDate} />
                                            </div>
                                        </div>
                                        <label className="form-control" htmlFor="checkExistDate"> Activar existencias a la fecha </label>
                                    </div>
                                </div>
                                <div className='col-12 col-lg-6'>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <div className="form-check input-group-text">
                                                <input
                                                    type="checkbox"
                                                    id="checkInformationBatch"
                                                    checked={ReportsModel.checkInformationBatch}
                                                    onClick={ChangeCheckInformationBatch} />
                                            </div>
                                        </div>
                                        <label className="form-control" htmlFor="checkInformationBatch"> Mostrar información de lotes </label>
                                    </div>
                                </div>
                                <div className='col-12 col-lg-6'>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <div className="form-check input-group-text">
                                                <input
                                                    type="checkbox"
                                                    id="checkExistNegative"
                                                    checked={ReportsModel.checkExistNegative}
                                                    onClick={ChangeCheckExistNegative} />
                                            </div>
                                        </div>
                                        <label className="form-control" htmlFor="checkExistNegative"> Mostrar solo existencias negativas </label>
                                    </div>
                                </div>
                                <div className='col-12 col-lg-6'>
                                    {ReportsModel.checkExistDate &&
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold"> Fecha </span>
                                            </div>
                                            <input
                                                type="date"
                                                className="form-control"
                                                max={ActualDate}
                                                value={ReportsModel.InitialDate}
                                                onChange={(event) => ChangeInitialDate(event)} />
                                        </div>
                                    }
                                </div> */}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" >Cancelar</button>
                            <button type="button" className="btn btn-primary" onClick={() => GenerateReportStocks()}>Generar</button>
                        </div>
                    </div>
                </div>

                <PdfViewer
                    DocsToPrint={ListReports}
                    TypeDoc={TypeDoc}
                    EnableEditButton={false}
                    Editable={false}
                    ChangeEditableMode={false}
                    EditableDocModel={'SalesTools.EditableDocModel'}
                    RefreshDocModel={'SalesTools.RefreshDocModel'}
                    SaveChanges={'SalesTools.SaveChangesOrderInvoice'}
                    UploadDoc={'SalesTools.UploadInvoice'}
                    EditParam1={false}
                    ShowPDFViewer={() => { ShowPDFViewer(); CleanReportModel(); }}
                    user={'user'}
                    Counter={true}
                    ReportsModel={ReportsModel}
                    MailTools={MailTools}
                    printhide={printhide}
                    ShowFormatToPrint={ShowFormatToPrint}
                    reprint={false}
                />

            </div>
        );
    }
}

export default ReportStocksModal;